import { FormattedMessage as FM } from "react-intl";

import { QrCodeIcon } from "components/Icons";
import { STYLE_ACTION_BUTTON_PRIMARY, VIEW_ENGAGE } from "../constants";

function QrMissingLink({ onOpen }) {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-3 rounded-lg border border-neutral-200 bg-white p-6 text-center shadow-sm">
      <span className="flex size-12 items-center justify-center rounded-full bg-sky-950 text-white">
        <QrCodeIcon width={22} className="fill-current" />
      </span>
      <h2 className="font-semibold text-neutral-800">
        <FM id="melhous.dash.qr.no_link" />
      </h2>
      <p className="text-sm text-neutral-500">
        <FM id="melhous.dash.qr.no_link_help" />
      </p>
      <button
        type="button"
        onClick={() => onOpen(VIEW_ENGAGE)}
        className={STYLE_ACTION_BUTTON_PRIMARY}
      >
        <FM id="melhous.dash.qr.no_link_action" />
      </button>
    </div>
  );
}

export default QrMissingLink;
